import { Box, Container, Typography } from "@mui/material";
import { useLanguage } from "../../i18n/LanguageContext";
import "./outcomes.css";

const content = {
    en: {
        title: "Results you can measure",
        intro: "Every Smart Key capability is tied to a hotel outcome, measured against your own numbers.",
        rows: [
            ["AI text and voice ordering, plus flexible access", "A smoother guest journey"],
            ["Predictive maintenance alerts and housekeeping workflows", "Faster issue response and clearer accountability"],
            ["Power-saving sensors", "Up to 40% lower electricity bill"],
            ["Smart parking", "Better use of parking and a new revenue stream"],
        ],
        assessment: ["Your baseline", "Your selected scope", "Your realized results"],
        assessmentNote: "We assess results with your own figures: where you start, what you choose, and what you achieve.",
    },
    ar: {
        title: "نتائج يمكنك قياسها",
        intro: "ترتبط كل قدرة في ضياف بنتيجة ملموسة لفندقك، تُقاس وفق أرقامك أنت.",
        rows: [
            ["الطلب بالذكاء الاصطناعي نصاً وصوتاً، مع مرونة الدخول", "رحلة أكثر سلاسة للضيف"],
            ["تنبيهات الصيانة التنبؤية وسير عمل التدبير المنزلي", "استجابة أسرع للمشكلات ومسؤوليات أوضح"],
            ["مستشعرات توفير الطاقة", "خفض فاتورة الكهرباء بنسبة تصل إلى 40%"],
            ["المواقف الذكية", "استغلال أفضل للمواقف ومصدر دخل جديد"],
        ],
        assessment: ["وضعك الحالي", "النطاق الذي تختاره", "النتائج المحققة"],
        assessmentNote: "نقيس النتائج بأرقامك أنت: من أين تبدأ، وماذا تختار، وماذا تحقق.",
    },
};

const Outcomes = () => {
    const { lang } = useLanguage();
    const c = content[lang];
    return (
        <>
            <Container maxWidth="lg" className="outcomesSection" id="outcomesSection">
                <Typography variant="h3" align="center" gutterBottom>
                    {c.title}
                </Typography>
                <Typography variant="subtitle1" align="center" className="outcomesIntro">
                    {c.intro}
                </Typography>

                <Box className="outcomesList">
                    {c.rows.map(([capability, outcome]) => (
                        <Box className="outcomesRow" key={capability}>
                            <Typography className="outcomesCapability">{capability}</Typography>
                            <span className="outcomesArrow" aria-hidden="true"></span>
                            <Typography className="outcomesResult">{outcome}</Typography>
                        </Box>
                    ))}
                </Box>

                <Box className="outcomesAssessment">
                    {c.assessment.map((step, index) => (
                        <Box className="outcomesStep" key={step}>
                            <span>{index + 1}</span>
                            <Typography>{step}</Typography>
                        </Box>
                    ))}
                </Box>
                <Typography align="center" className="outcomesNote">
                    {c.assessmentNote}
                </Typography>
            </Container>
        </>
    )
}
export default Outcomes;
